import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchAddTransform, fetchDeleteTransform, fetchGetDetailTransform, fetchGetTransform, fetchGetTransformTemplates, fetchTransformNewExtraction } from "../services/transformationServices";

export const useTransformList = () =>{
    return useQuery({
        queryKey: ["transform"],
        queryFn: () => fetchGetTransform(),
        staleTime: 5 * 60 * 1000, // 5 min
    });
}

export const useTransformListTemplates = () =>{
  return useQuery({
      queryKey: ["transform-templates"],
      queryFn: () => fetchGetTransformTemplates(),
      staleTime: 5 * 60 * 1000, // 5 min
  });
}

export const useTransformDetail = (id) =>{
    return useQuery({
        queryKey: ["transform-detail", id],
        queryFn: () => fetchGetDetailTransform(id),
        enabled: !!id,
        staleTime: 5 * 60 * 1000, // 5 min
    });
}

export const useAddTransform = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: fetchAddTransform,

    // refresh connection list
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transform'] });
    }
  });
};

export const useTransformNewExtraction = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: fetchTransformNewExtraction,

    // refresh connection list
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transform'] });

      queryClient.invalidateQueries({
        queryKey: ['extraction']
      });
    }
  });
};

export const useDeleteTransform = () => {
    const queryClient = useQueryClient();
  
    return useMutation({
      mutationFn: fetchDeleteTransform,
  
      // refresh connection list
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['transform'] });
      }
    });
  };

